import { cn } from "@/lib/utils";
import { IconCheck } from "@tabler/icons-react";
import Image from "next/image";
import PillButton from "./ui/button/pillButton";
import { ModeButton } from "./ui/button/ModeButton";

interface PillModeContentProps {
  icon: string;
  title: string;
  mode: "blue" | "red";
  points: string[];
  buttonText: string;
}

export const colorMap = {
  blue: {
    checkBg: "bg-[#132345]",
    borderColor: "border-[#132345]",
    button: "bg-gradient-blue-dark",
  },
  red: {
    checkBg: "bg-[#39141A]",
    button: "bg-gradient-red-dark",
    borderColor: "border-[#39141A]",
  },
};

export const PillModeContent = ({
  icon,
  title,
  mode,
  points,
  buttonText,
}: PillModeContentProps) => {
  const theme = colorMap[mode];
  return (
    <div className="flex justify-start h-full md:gap-6 gap-3">
      <div className="flex flex-col justify-center items-center">
        <div
          className={cn(
            "bg-background border-2 flex rounded-full p-1",
            theme.borderColor
          )}
        >
          <PillButton className="md:size-14 size-10" bgColor={theme.checkBg}>
            <Image
              src={icon}
              alt="pill icon"
              width={48}
              height={48}
              className="object-contain"
            />
          </PillButton>
        </div>
        <div
          className={cn(
            "top-0 z-10 w-1 h-full",
            mode === "blue"
              ? "bg-gradient-to-b from-blue-900 to-blue-900/0"
              : "bg-gradient-to-b from-red-900 to-red-900/0"
          )}
        >
          <div
            className={cn(
              "top-0 z-10 w-1 h-full blur-sm",
              mode === "blue"
                ? "bg-gradient-to-b from-blue-500 to-blue-500/0"
                : "bg-gradient-to-b from-red-500 to-red-500/0"
            )}
          />
        </div>
      </div>
      <div className="flex flex-col md:gap-6 gap-3 pb-8">
        <div className="flex flex-col  md:gap-6 gap-3">
          {/* Title */}
          <div className="flex items-center gap-3 h-14">
            <h3 className="text-white sm:text-3xl text-lg font-semibold">
              {title}
            </h3>
          </div>

          {/* Feature List */}
          <ul className="flex flex-col gap-4">
            {points.map((point, idx) => (
              <li
                key={idx}
                className="flex items-center justify-start gap-3 text-sm text-white"
              >
                <PillButton
                  className=""
                  bgColor={theme.checkBg}
                  borderGradient={theme.button}
                  aria-label="mode check mark"
                  name="check mark"
                >
                  <IconCheck
                    stroke={2}
                    className={"text-white md:h-auto h-3 w-auto"}
                  />
                </PillButton>
                <p className="text-left sm:text-base text-xs text-[#CAC6DD]">
                  {point}
                </p>
              </li>
            ))}
          </ul>
        </div>

        {/* CTA Button */}

        <ModeButton label={buttonText} mode={mode} />
      </div>
    </div>
  );
};
